<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="3" md="6" sm="12">
        <v-autocomplete v-model="queryForm.postlineid" :items="postlines" label="线路" outlined dense clearable
          :menu-props="{ bottom: true, offsetY: true }">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="6" sm="12">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" tile @click="showadd">
            <v-icon small>mdi-plus</v-icon> 新增线路
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="name" slot-scope="text, record">
          <p> {{ record.name }}<span :class="{
            'primary--text': record.transport_kind === '单程',
            'error--text': record.transport_kind === '往返'
          }">[{{ record.transport_kind }}]</span></p>
        </template>
        <template slot="line" slot-scope="text, record">
          <p v-if="record.line1">{{ record.line1.from.text }}→{{ record.line1.to.text }}</p>
          <p v-if="record.line2">{{ record.line2.from.text }}→{{ record.line2.to.text }}</p>
        </template>
        <template slot="create_time" slot-scope="text, record">
          {{ record.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="success" @click="showedit(record)"> 编辑 </v-btn>
            <a-popconfirm title="删除线路" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="model" persistent max-width="600px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete v-model="form.postlineid" :items="postlines" :rules="[vrules.required]" outlined dense
                    :menu-props="{ bottom: true, offsetY: true }" @change="changePostLine">
                    <template v-slot:label>
                      线路 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete v-model="form.departure1" :items="locations" :rules="[vrules.required]" outlined dense
                    :menu-props="{ bottom: true, offsetY: true }">
                    <template v-slot:label>
                      去程出发地 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete v-model="form.destination1" :items="locations" :rules="[vrules.required]" outlined
                    dense :menu-props="{ bottom: true, offsetY: true }">
                    <template v-slot:label>
                      去程目的地 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <template v-if="form.transport_kind === '往返'">
                  <v-col cols="12" md="6">
                    <v-autocomplete v-model="form.departure2" :items="locations" :rules="[vrules.required]" outlined
                      dense :menu-props="{ bottom: true, offsetY: true }">
                      <template v-slot:label>
                        返程出发地 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete v-model="form.destination2" :items="locations" :rules="[vrules.required]" outlined
                      dense :menu-props="{ bottom: true, offsetY: true }">
                      <template v-slot:label>
                        返程目的地 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "MapLine2",
  data() {
    return {
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      queryForm: {
        postlineid: "",
      },
      postlines: [],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "名称", dataIndex: "name", scopedSlots: { customRender: "name" }, width: 120, align: "center" },
        { title: "路径", dataIndex: "line", scopedSlots: { customRender: "line" }, width: 200, align: "center" },
        { title: "操作时间", dataIndex: "optime", scopedSlots: { customRender: "optime" }, width: 120, align: "center" },
        { title: "操作人", dataIndex: "opby", scopedSlots: { customRender: "opby" }, width: 120, align: "center" },
        { title: "备注", dataIndex: "desc", scopedSlots: { customRender: "desc" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      valid: true,
      model: false,
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      locations: [],
      form: {
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  activated() {
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/map/line2/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.postlines = res.data.postlines;
          this.locations = res.data.locations;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = {
        _id: "",
        postlineid: null,
        transport_kind: null,
        departure1: null,
        destination1: null,
        departure2: null,
        destination2: null,
      };
      this.modeltitle = "新增线路";
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        postlineid: item.postlineid,
        transport_kind: item.transport_kind,
        departure1: item.departure1,
        destination1: item.destination1,
        departure2: item.departure2,
        destination2: item.destination2,
      };
      this.modeltitle = "编辑线路";
      this.model = true;
    },
    changePostLine(v) {
      let postline = this.postlines.find(n => n.value === v);
      this.form.transport_kind = postline.transport_kind;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/map/line2/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/map/line2/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-text-field__details {
  margin-bottom: 0 !important;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
